// extracted by mini-css-extract-plugin
export default {"headerText":"Header_headerText__lA6pU","nowrap-true":"Header_nowrap-true__-J5zo","active-true":"Header_active-true__9zN1n","active-red-true":"Header_active-red-true__VJzdI"};